import { Job as JobModel } from '@models/Job'
import { getJobs, selectJobs, setJobQuery } from '@store/JobReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { useAppDispatch, useAppSelector } from '@utils/hooks'
import { extractSortDataFromSorterResult } from '@utils/table/sorter'
import { Flex, TableColumnsType, TableProps } from 'antd'
import { useEffect, useState } from 'react'

const JobsPage = () => {
  const { isOpen } = useSBRM()
  const dispatch = useAppDispatch()
  const items = useAppSelector(selectJobs())
  const { query, isLoading } = useAppSelector((state) => state.job)
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true)

  const columns: TableColumnsType<JobModel> = [
    {
      key: 'name',
      title: 'Nom',
      render: (record: JobModel) => record.name,
    },

    {
      key: 'actions',
      align: 'right',
      render: (record: JobModel) => (
        <SBRM.Actions
          actions={[SBRMAction.Update, SBRMAction.Delete]}
          entity={Entity.job}
          entityId={record.id}
        />
      ),
    },
  ]

  const handleTableChange: TableProps<JobModel>['onChange'] = (
    pagination,
    filters,
    sorter
  ) => {
    const newQuery: TableParams = {
      pagination,
      filters,
      ...extractSortDataFromSorterResult(sorter),
    }
    dispatch(setJobQuery(newQuery))
    dispatch(getJobs(newQuery))
  }

  useEffect(() => {
    if (!isFirstRender && isOpen) {
      return
    }
    setIsFirstRender(false)
    // Trigger on init and when SBRM is closed
    dispatch(getJobs(query))
  }, [dispatch, isOpen])

  return (
    <Flex vertical>
      <PageTitle
        title="Postes"
        level={5}
        toolbar={
          <SBRM.Actions entity={Entity.job} actions={[SBRMAction.Create]} />
        }
      />
      <SBTable
        scroll={{ x: 600 }}
        columns={columns}
        dataSource={items}
        pagination={query.pagination}
        loading={isLoading}
        onChange={handleTableChange}
      />
    </Flex>
  )
}

export default JobsPage
